import type { SVGProps } from 'react';
const SvgContacts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#contacts_svg__a)">
      <path
        fill="currentColor"
        d="M20 0H4v2h16V0ZM4 24h16v-2H4v2ZM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75ZM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17Z"
      />
    </g>
    <defs>
      <clipPath id="contacts_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgContacts;
